import styled, { css } from 'styled-components';
import { Atom } from 'AppReact';

const template = styled.input`
    ${({ displayState }) => css`
        outline: none;
        height: 100%;
        width: 100%;
        padding-left: 12px;
        padding-right: 12px;
        background-color: #F7F7F7;
        border: ${displayState?.hideBorder ? '' : '1px solid #E3E3E3'};
    `}
`;

export default Atom({ type: 'input', dataType: 'string', template })